export default __webpack_public_path__ + "asset/img/close~d5bde6d7.png";